import { render, staticRenderFns } from "./Parceria_fiel.vue?vue&type=template&id=c6481f7e&scoped=true"
import script from "./Parceria_fiel.vue?vue&type=script&lang=js"
export * from "./Parceria_fiel.vue?vue&type=script&lang=js"
import style0 from "./Parceria_fiel.vue?vue&type=style&index=0&id=c6481f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6481f7e",
  null
  
)

export default component.exports